<template>
  <CCardBody>
    <ul class="py-1">
      <li class="">
        <div class="d-flex justify-content-between font-weight-bold">
          <span class="text-capitalize font-xl text-gray-800">
            {{ $t(`manageplan.component.card.plan.${planName.toLowerCase()}`) }}
            <CBadge v-if="planName == 'professional'" class="text-uppercase bg-gray-200 text-gray-500 px-2 py-1 font-xs ml-2">
              {{ $t(`manageplan.component.card.plan.recomended`) }}</CBadge
            >

            <a href="#" class="d-block font-sm" @click.prevent="setModal({ modalName: 'modalPlanDetails' })" v-if="planFeatures">
              {{ $t(`manageplan.component.card.plan.viewDetails`) }}</a
            >
          </span>
          <span class="text-gray-600"> {{ $t(`manageplan.component.card.plan.period.${period}`) }} </span>
        </div>
      </li>
      <li class="d-flex justify-content-between">
        <span class="font-weight-bold text-gray-800">{{ contacts }} {{ $t(`manageplan.component.card.plan.contacts`) }}</span>
        <span>
          <CIcon name="users" :height="25" viewBox="0 0 32 32" size="custom-size" class="mr-2 text-gray-700" />
        </span>
      </li>
      <li class="d-flex justify-content-between">
        <span class="font-weight-bold text-gray-800">{{ emails }} {{ $t(`manageplan.component.card.plan.emails`) }}</span>
        <span>
          <CIcon name="emailNew" :height="20" viewBox="0 0 39 32" class="mr-2 text-gray-700" />
        </span>
      </li>
    </ul>
  </CCardBody>
</template>

<script>
export default {
  name: 'CardPlan',
  computed: {
    isSummary() {
      return this.place == 'summary'
    },
    planName() {
      return this.$store.state.backOffice.steps.selectedPlanName
    },
    mount() {
      return this.$store.state.backOffice.steps.mount
    },
    emails() {
      return this.$store.state.backOffice.steps.maxEmailsIncluded
    },
    contacts() {
      return this.$store.state.backOffice.steps.maxAudience
    },
    period() {
      return this.$store.state.backOffice.steps.paymentPeriod
    },
    planFeatures() {
      return this.$store.state.backOffice.steps.selectedPlanName
    },
  },
  methods: {
    setModal(component) {
      this.$store.dispatch('backOffice/steps/setModalComponent', component)
    },
  },
}
</script>

<style lang="scss"></style>
